module.exports = __webpack_public_path__ + "static/media/Hockey Player.b5526419.jpg";